import useFetch from '../../../hooks/useFetch';
import chauffeurApi from '../chauffeurApi';

export default function useEnvoyerPositionChauffeurApi() {
    return useFetch(chauffeurApi.envoyerPosition);
}
